/**
 * Returns a list of words that look like the participles used for the Slovak passive voice assessment.
 * This list only includes words that look like participles ending in -re and -ra.
 *
 * @returns {Array}                The list with words that look like participles.
 */
export default [
	"letá",
	"skriptá",
	"dvojitá",
	"autá",
	"kráľovná",
	"princezná",
	"príbuzná",
	"premenná",
	"trstená",
	"zelená",
	"ošípaná",
	"lesná",
	"vyvolená",
	"dobšiná",
	"hádzaná",
	"gazdiná",
	"šrotovná",
	"švagriná",
	"výborná",
	"záverečná",
	"recepčná",
	"konečná",
	"dotyčná",
	"černá",
	"jediný",
	"posledný",
	"ostatný",
	"neposledný",
	"predposledný",
	"štvrtý",
	"dvojitý",
	"postihnutý",
	"svätý",
	"zlotý",
	"dôležitý",
	"istý",
	"určitý",
	"svätý",
	"bohatý",
	"čistý",
	"zlatý",
	"častý",
	"postihnutý",
	"zložitý",
	"okolitý",
	"žltý",
	"dohodnutý",
	"skrytý",
	"hustý",
	"okamžitý",
	"zvyknutý",
	"krutý",
	"zahrnutý",
	"vzniknutý",
	"vyvinutý",
	"dotknutý",
	"rozhodnutý",
	"rozmanitý",
	"rozvinutý",
	"pokrytý",
	"krytý",
	"opitý",
	"tekutý",
	"spätý",
	"neistý",
	"prostý",
	"nepretržitý",
	"osobitý",
	"prevzatý",
	"jedovatý",
	"zapnutý",
	"ukradnutý",
	"mletý",
	"ženatý",
	"sprostý",
	"trávnatý",
	"uhličitý",
	"maloletý",
	"nevyužitý",
	"prežitý",
	"skalnatý",
	"ponúknutý",
	"rozbehnutý",
	"vydatý",
	"náležitý",
	"napätý",
	"pustý",
	"prenajatý",
	"zvládnutý",
	"vypnutý",
	"pracovitý",
	"zasiahnutý",
	"neurčitý",
	"piesočnatý",
	"šitý",
	"šťavnatý",
	"zamrznutý",
	"posadnutý",
	"posunutý",
	"urcitý",
	"listnatý",
	"guľatý",
	"nečistý",
	"dutý",
	"ihličnatý",
	"chlpatý",
	"nápaditý",
	"zaujatý",
	"nedotknutý",
	"členitý",
	"presunutý",
	"menovitý",
	"hranatý",
	"odobratý",
	"zamknutý",
	"zdvihnutý",
	"natiahnutý",
	"rovinatý",
	"zabehnutý",
	"novovzniknutý",
	"potiahnutý",
	"odtrhnutý",
	"hornatý",
	"zamietnutý",
	"vyzretý",
	"opretý",
	"kamenistý",
	"kľukatý",
	"svalnatý",
	"zarytý",
	"prehratý",
	"zajatý",
	"rozpačitý",
	"pohnutý",
	"rozkvitnutý",
	"stojatý",
	"húževnatý",
	"zlatistý",
	"opuchnutý",
	"hmlistý",
	"prekrytý",
	"vychudnutý",
	"napnutý",
	"plnoletý",
	"odumretý",
	"očitý",
	"dojatý",
	"strapatý",
	"korenistý",
	"stuhnutý",
	"ostnatý",
	"neplnoletý",
	"odetý",
	"zákonitý",
	"vyňatý",
	"vyschnutý",
	"obutý",
	"ohnutý",
	"vlnitý",
	"nafúknutý",
	"zapadnutý",
	"vystretý",
	"mäsitý",
	"svedomitý",
	"spadnutý",
	"vytiahnutý",
	"špicatý",
	"znamenitý",
	"nepoužitý",
	"ostražitý",
	"tretý",
	"nekrytý",
	"uzamknutý",
	"tienistý",
	"zovretý",
	"nultý",
	"tlstý",
	"rázovitý",
	"ľudnatý",
	"pospolitý",
	"hlasitý",
	"vychladnutý",
	"rozpadnutý",
	"odňatý",
	"pritiahnutý",
	"nedožitý",
	"klenutý",
	"pretiahnutý",
	"podlhovastý",
	"dvojitý",
	"zaťatý",
	"podnapitý",
	"prasknutý",
	"prikrytý",
	"padnutý",
	"vypätý",
	"podčiarknutý",
	"roztiahnutý",
	"svatý",
	"mrzutý",
	"kopcovitý",
	"svahovitý",
	"guľovitý",
	"zásaditý",
	"bradatý",
	"zmrznutý",
	"zubatý",
	"pomletý",
	"zaniknutý",
	"zažitý",
	"piesčitý",
	"zahnutý",
	"nasiaknutý",
	"zhnitý",
	"iný",
	"posledný",
	"jediný",
	"vlastný",
	"hlavný",
	"pekný",
	"povinný",
	"určený",
	"vhodný",
	"schopný",
	"plný",
	"samotný",
	"silný",
	"pripravený",
	"voľný",
	"podobný",
	"spokojný",
	"pracovný",
	"súčasný",
	"presvedčený",
	"uvedený",
	"medzinárodný",
	"osobný",
	"spoločný",
	"daný",
	"národný",
	"základný",
	"úspešný",
	"potrebný",
	"neregistrovaný",
	"rodinný",
	"kvalitný",
	"finančný",
	"zodpovedný",
	"šťastný",
	"skutočný",
	"pôvodný",
	"dnešný",
	"otvorený",
	"zameraný",
	"príjemný",
	"ročný",
	"bežný",
	"životný",
	"výborný",
	"možný",
	"stavebný",
	"ochotný",
	"významný",
	"zdravotný",
	"vnútorný",
	"obyčajný",
	"hudobný",
	"duchovný",
	"presný",
	"jasný",
	"verejný",
	"vybavený",
	"príslušný",
	"priemerný",
	"červený",
	"výrazný",
	"samostatný",
	"spojený",
	"odborný",
	"výkonný",
	"trestný",
	"umiestnený",
	"moderný",
	"schválený",
	"obchodný",
	"cestovný",
	"informačný",
	"spomínaný",
	"vytvorený",
	"nádherný",
	"dostatočný",
	"oprávnený",
	"mobilný",
	"zelený",
	"náročný",
	"úžasný",
	"obľúbený",
	"jedinečný",
	"prirodzený",
	"prítomný",
	"obecný",
	"slušný",
	"kompletný",
	"prekvapený",
	"dostupný",
	"operačný",
	"pevný",
	"večný",
	"dolný",
	"zvýšený",
	"výnimočný",
	"krvný",
	"stanovený",
	"súkromný",
	"konečný",
	"vianočný",
	"vážený",
	"ústavný",
	"úplný",
	"obmedzený",
	"považovaný",
	"skúsený",
	"platný",
	"slobodný",
	"vyrobený",
	"tradičný",
	"nebezpečný",
	"verný",
	"vodný",
	"všeobecný",
	"smutný",
	"dopravný",
	"letný",
	"mesačný",
	"prírodný",
	"drevený",
	"osobitný",
	"komplexný",
	"nočný",
	"vzdialený",
	"denný",
	"farebný",
	"okresný",
	"študijný",
	"účinný",
	"volebný",
	"policajný",
	"používaný",
	"jemný",
	"záverečný",
	"sklamaný",
	"unavený",
	"menovaný",
	"pokojný",
	"zaradený",
	"rozšírený",
	"poškodený",
	"odlišný",
	"pravidelný",
	"poverený",
	"rozdelený",
	"bezpečný",
	"územný",
	"zahraničný",
	"slnečný",
	"nepríjemný",
	"horný",
	"jednotný",
	"zásadný",
	"inteligentný",
	"opačný",
	"zimný",
	"dotyčný",
	"vďačný",
	"víťazný",
	"stručný",
	"každodenný",
	"slávnostný",
	"podrobný",
	"imunitný",
	"stredný",
	"značný",
	"akčný",
	"šikovný",
	"prístupný",
	"výsledný",
	"funkčný",
	"tohtoročný",
	"nevyhnutný",
	"orientovaný",
	"ostatný",
	"nadšený",
	"bezpečnostný",
	"studený",
	"štandardný",
	"zverejnený",
	"situovaný",
	"plánovaný",
	"ochranný",
	"podstatný",
	"dlhoročný",
	"perfektný",
	"cirkevný",
	"takzvaný",
	"zložený",
	"nevhodný",
	"úprimný",
	"stolný",
	"stabilný",
	"požadovaný",
	"čestný",
	"anonymný",
	"lacný",
	"reklamný",
	"úvodný",
	"kontrolný",
	"nasledovný",
	"výrobný",
	"zábavný",
	"viditeľný",
	"divadelný",
	"písomný",
	"predpokladaný",
	"medziročný",
	"lesný",
	"odolný",
	"registrovaný",
	"prípadný",
	"nešťastný",
	"jednoznačný",
	"spôsobený",
	"chudobný",
	"udržateľný",
	"luxusný",
	"zadný",
	"rozumný",
	"tanečný",
	"organizačný",
	"drobný",
	"zranený",
	"zasvätený",
	"rovný",
	"užitočný",
	"investičný",
	"milovaný",
	"hodný",
	"hladný",
	"bezplatný",
	"pripojený",
	"nekonečný",
	"zemný",
	"elegantný",
	"pomocný",
	"zbytočný",
	"priemyselný",
	"pohodlný",
	"obvodný",
	"mocný",
	"pitný",
	"oblečený",
	"neobmedzený",
	"strávený",
	"plnohodnotný",
	"rodný",
	"vzájomný",
	"prípravný",
	"zaznamenaný",
	"kamenný",
	"kompaktný",
	"vstupný",
	"zabudovaný",
	"peňažný",
	"skromný",
	"mohutný",
	"externý",
	"výskumný",
	"ohrozený",
	"predný",
	"reprezentačný",
	"primeraný",
	"herný",
	"výhodný",
	"strašný",
	"ný",
	"polovičný",
	"nezabudnuteľný",
	"invalidný",
	"narodený",
	"cenný",
	"následný",
	"opatrný",
	"ocenený",
	"ústredný",
	"sprievodný",
	"svadobný",
	"prepracovaný",
	"neuveriteľný",
	"zákonný",
	"variabilný",
	"využívaný",
	"zariadený",
	"napojený",
	"strieborný",
	"nazvaný",
	"tajný",
	"komunikačný",
	"novotný",
	"západný",
	"zachovaný",
	"nenávratný",
	"vzdelaný",
	"kladný",
	"poistený",
	"dobrovoľný",
	"ucelený",
	"označovaný",
	"komerčný",
	"vydarený",
	"dočasný",
	"prihlásený",
	"hrozný",
	"vtipný",
	"chladný",
	"kontaktný",
	"komplikovaný",
	"znížený",
	"záväzný",
	"jarný",
	"večerný",
	"odvodený",
	"pohlavný",
	"obklopený",
	"zamestnaný",
	"dôstojný",
	"odkázaný",
	"liečebný",
	"netradičný",
	"celodenný",
	"naivný",
	"riadený",
	"severný",
	"falošný",
	"náhodný",
	"južný",
	"prechodný",
	"talentovaný",
	"závažný",
	"dvojnásobný",
	"jubilejný",
	"nominovaný",
	"nedostatočný",
	"telekomunikačný",
	"nainštalovaný",
	"použiteľný",
	"dodávaný",
	"súťažný",
	"prispôsobený",
	"pripravovaný",
	"nespokojný",
	"získaný",
	"tajomný",
	"financovaný",
	"ponúkaný",
	"výtvarný",
	"svetelný",
	"zmenený",
	"položený",
	"vykonaný",
	"zmluvný",
	"vyvážený",
	"vysvätený",
	"potvrdený",
	"sprevádzaný",
	"limitovaný",
	"služobný",
	"postupný",
	"podporený",
	"registračný",
	"vrchný",
	"nezamestnaný",
	"obytný",
	"zostavený",
	"vyplnený",
	"príbuzný",
	"prezentovaný",
	"duševný",
	"podaný",
	"nevinný",
	"tepelný",
	"priestranný",
	"ľahostajný",
	"pridelený",
	"náučný",
	"zaručený",
	"pozoruhodný",
	"rekordný",
	"zaslaný",
	"nahnevaný",
	"platený",
	"ľubovoľný",
	"platobný",
	"navrhovaný",
	"volený",
	"ozajstný",
	"podporovaný",
	"úradný",
	"pozorný",
	"záručný",
	"predčasný",
	"týždenný",
	"prepojený",
	"nutný",
	"popredný",
	"vymenovaný",
	"pilotný",
	"požehnaný",
	"kombinovaný",
	"redakčný",
	"zubný",
	"telesný",
	"minuloročný",
	"ranný",
	"temný",
	"realitný",
	"vyriešený",
	"neschopný",
	"zázračný",
	"revolučný",
	"interný",
	"parný",
	"bočný",
	"zbavený",
	"cestný",
	"čudný",
	"urobený",
	"šialený",
	"animovaný",
	"veľkonočný",
	"nudný",
	"predbežný",
	"oslobodený",
	"divný",
	"hraničný",
	"prenosný",
	"kvalifikovaný",
	"prvotný",
	"motivačný",
	"obžalovaný",
	"záhradný",
	"odovzdaný",
	"podmienený",
	"východný",
	"dominantný",
	"spätný",
	"nákladný",
	"nenápadný",
	"jesenný",
	"výchovný",
	"predmetný",
	"detailný",
	"drsný",
	"špecializovaný",
	"obranný",
	"prehľadný",
	"vyhradený",
	"pyšný",
	"spustený",
	"podpivničený",
	"osadený",
	"nečakaný",
	"porovnateľný",
	"prepustený",
	"nadriadený",
	"povolaný",
	"ovocný",
	"výmenný",
	"vyčerpaný",
	"obnovený",
	"písaný",
	"overený",
	"konkurenčný",
	"kompatibilný",
	"neúspešný",
	"starobný",
	"konverzný",
	"záchranný",
	"totožný",
	"zastúpený",
	"kompetentný",
	"spodný",
	"obohatený",
	"chutný",
	"firemný",
	"relevantný",
	"navigačný",
	"uvoľnený",
	"nasadený",
	"vyjadrený",
	"čiastočný",
	"pamätný",
	"posvätný",
	"uznaný",
	"pomenovaný",
	"očný",
	"kontroverzný",
	"flexibilný",
	"všestranný",
	"neskutočný",
	"zapojený",
	"kladený",
	"spotrebný",
	"oddelený",
	"nákupný",
	"prijateľný",
	"vyvolený",
	"vinný",
	"vyrábaný",
	"nájdený",
	"rekreačný",
	"chybný",
	"nemenovaný",
	"tučný",
	"neviditeľný",
	"poradný",
	"skalný",
	"celovečerný",
	"naladený",
	"zateplený",
	"hmotný",
	"colný",
	"zamilovaný",
	"polyfunkčný",
	"knižný",
	"podriadený",
	"hraný",
	"vymedzený",
	"nastaviteľný",
	"nedeľný",
	"priložený",
	"odstránený",
	"uzatvorený",
	"renesančný",
	"pružný",
	"regulačný",
	"poháňaný",
	"vstavaný",
	"hodnotný",
	"splnený",
	"vzdušný",
	"putovný",
	"zatvorený",
	"porazený",
	"vytúžený",
	"skrátený",
	"stíhaný",
	"knižničný",
	"realizačný",
	"zmiešaný",
	"pokrstený",
	"aplikovaný",
	"motivovaný",
	"testovaný",
	"vnímaný",
	"milosrdný",
	"úsporný",
	"vítaný",
	"čarovný",
	"zaslúžený",
	"nezvyčajný",
	"pokorný",
	"neopakovateľný",
	"protimonopolný",
	"učebný",
	"odhodlaný",
	"nádejný",
	"povestný",
	"železničný",
	"podporný",
	"obsadený",
	"zmätený",
	"výstižný",
	"oboznámený",
	"skúšobný",
	"nadmerný",
	"ozbrojený",
	"rodený",
	"čitateľný",
	"opozičný",
	"železný",
	"orientačný",
	"zavraždený",
	"zhodný",
	"kvalifikačný",
	"ukrižovaný",
	"autorizovaný",
	"ladený",
	"odporúčaný",
	"oddaný",
	"ohromný",
	"znechutený",
	"šokovaný",
	"predajný",
	"nenáročný",
	"smrteľný",
	"činný",
	"uväznený",
	"objavený",
	"sledovaný",
	"nosný",
	"vecný",
	"arogantný",
	"hradný",
	"zdatný",
	"vymyslený",
	"ohraničený",
	"počiatočný",
	"zanedbateľný",
	"radostný",
	"zrozumiteľný",
	"hybridný",
	"usporiadaný",
	"multifunkčný",
	"univerzitný",
	"palubný",
	"naklonený",
	"zadaný",
	"predposledný",
	"narušený",
	"naozajstný",
	"spasený",
	"udržiavaný",
	"zabalený",
	"komorný",
	"spáchaný",
	"stabilizačný",
	"záhadný",
	"osamotený",
	"stavaný",
	"dobrodružný",
	"nakrútený",
	"izolovaný",
	"zaťažený",
	"žiadaný",
	"reklamačný",
	"sviatočný",
	"premyslený",
	"vyhotovený",
	"bezprostredný",
	"údajný",
	"korektný",
	"dvojročný",
	"krstný",
	"obdobný",
	"vyvolaný",
	"nezmenený",
	"koncipovaný",
	"dodatočný",
	"opísaný",
	"žitný",
	"odoslaný",
	"zachytený",
	"všedný",
	"evidovaný",
	"jazdný",
	"černý",
	"vylepšený",
	"zaplatený",
	"porušený",
	"nevšedný",
	"odporný",
	"prospešný",
	"opakovaný",
	"trojročný",
	"prenesený",
	"slovný",
	"prerobený",
	"charakterizovaný",
	"začarovaný",
	"sobotný",
	"oplotený",
	"transparentný",
	"uskutočnený",
	"certifikovaný",
	"nekompromisný",
	"hromadný",
	"murovaný",
	"toaletný",
	"varovný",
	"diaľničný",
	"zavesený",
	"neplatný",
	"hnusný",
	"zlomený",
	"pokazený",
	"opravný",
	"kúpeľný",
	"nejasný",
	"zaľúbený",
	"akceptovaný",
	"servisný",
	"sústredený",
	"kožený",
	"výstavný",
	"nápomocný",
	"bezmocný",
	"mravný",
	"zaskočený",
	"kľudný",
	"enormný",
	"predaný",
	"rastlinný",
	"nepatrný",
	"odhalený",
	"spisovný",
	"preplnený",
	"oslabený",
	"žalovaný",
	"útočný",
	"nadaný",
	"smädný",
	"voliteľný",
	"satelitný",
	"účtovný",
	"záložný",
	"brušný",
	"predvolebný",
	"pravdepodobný",
	"benefičný",
	"relaxačný",
	"nižný",
	"diskusný",
	"vyslaný",
	"komfortný",
	"povýšený",
	"zaužívaný",
	"renomovaný",
	"zaistený",
	"vzkriesený",
	"výstupný",
	"poslušný",
	"nežný",
	"osobnostný",
	"hľadaný",
	"predurčený",
	"nezmyselný",
	"predvedený",
	"poistný",
	"upozornený",
	"poľný",
	"úložný",
	"referenčný",
	"robustný",
	"nenahraditeľný",
	"zhubný",
	"bezchybný",
	"dvojpodlažný",
	"vyšný",
	"nájomný",
	"predkladaný",
	"neškodný",
	"celoročný",
	"stabilizovaný",
	"nefunkčný",
	"záporný",
	"súhrnný",
	"opätovný",
	"vznešený",
	"zasadený",
	"celoživotný",
	"tolerantný",
	"statočný",
	"zmysluplný",
	"sprístupnený",
	"odmenený",
	"textilný",
	"zhotovený",
	"strešný",
	"konštantný",
	"priznaný",
	"vyradený",
	"bojovný",
	"vyvíjaný",
	"zakopaný",
	"permanentný",
	"nevídaný",
	"koaličný",
	"odložený",
	"teplotný",
	"priebežný",
	"rovnocenný",
	"pripútaný",
	"uvádzaný",
	"obrátený",
	"zreteľný",
	"adresovaný",
	"vymastený",
	"kultivovaný",
	"dlžný",
	"vytlačený",
	"blahoslavený",
	"zverený",
	"umožnený",
	"percentný",
	"prenasledovaný",
	"zjavný",
	"pozáručný",
	"zaneprázdnený",
	"chápaný",
	"ubytovaný",
	"nerozhodný",
	"neautorizovaný",
	"prerokovaný",
	"vypredaný",
	"vyzvaný",
	"približný",
	"nemožný",
	"operný",
	"zjednodušený",
	"prezývaný",
	"vyznačený",
	"zvyšný",
	"recyklačný",
	"komunitný",
	"trojnásobný",
	"excelentný",
	"zablokovaný",
	"koncentrovaný",
	"stlačený",
	"jednosmerný",
	"posilnený",
	"jednostranný",
	"neobyčajný",
	"vymenený",
	"totalitný",
	"kúpený",
	"garantovaný",
	"zadržaný",
	"neprijateľný",
	"zrealizovaný",
	"želaný",
	"dôsledný",
	"rýchlostný",
	"robený",
	"ručný",
	"využiteľný",
	"zachránený",
	"nerušený",
	"parlamentný",
	"dedičný",
	"predávaný",
	"vysnívaný",
	"vysielaný",
	"rekonštruovaný",
	"útulný",
	"doživotný",
	"ropný",
	"propagačný",
	"poučený",
	"mastný",
	"koncertný",
	"aktivovaný",
	"zberný",
	"prerušený",
	"otočený",
	"civilný",
	"šetrný",
];
